import { Guid } from "@/types"
import Notification, { IGetNotification, NotificationType } from "./Notification"
import NotificationAsset, { IGetNotificationAssetDto } from "./NotificationAsset"

export interface IGetNotificationUnplannedAssetStoredDto extends IGetNotification {
    notificationType: NotificationType.unplannedAssetStored
    reservationId: Guid
    reservationNumber: string
    assetId: Guid
    asset?: IGetNotificationAssetDto
    withoutShippingOrder?: boolean | null
    comment?: string | null
}

export default class NotificationUnplannedAssetStored extends Notification {
    reservationId: Guid
    reservationNumber: string
    asset: NotificationAsset
    withoutShippingOrder: boolean
    comment?: string

    constructor(dto: IGetNotificationUnplannedAssetStoredDto) {
        super(dto)
        this.reservationId = dto.reservationId
        this.reservationNumber = dto.reservationNumber
        this.asset = new NotificationAsset({
            assetId: dto.assetId
        })
        this.withoutShippingOrder = dto.withoutShippingOrder || false
        this.comment = dto.comment ?? undefined
    }
}
